import { useAuth } from "providers/authProvider";
import LoadingScreen from "../components/loading-screen";
import AuthUtil from "../utils/auth-utils";
import NotAuthorizedScene from "./not-authorized";

export const RequiredAdminAuth = ({ children }: { children: JSX.Element }) => {
    let auth = useAuth();

    if (!auth.isAuthenticated())
        auth.signinRedirect();

    let isAdmin = AuthUtil.IsAdmin();

    if (!isAdmin) {
        return <NotAuthorizedScene />;
    }

    return children;
};